import { getOr } from '@/utils/options';
import { Subheading } from 'components/src/typography';
import Link from 'next/link';
import * as React from 'react';
import {
  LinkCategoryFieldsFragment,
  LinkFieldsFragment,
  NavbarLinkWithDescriptionFieldsFragment,
} from 'types/generated';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import LinkWithDescription from './LinkWithDescription';
import { useSetAtom } from 'jotai';
import { isFullscreenExhaustedAtom } from '@/store';

type Props = {
  data?: LinkCategoryFieldsFragment | null;
  showMobileMenu: boolean;
  idx: number;
};

const MotionSubheading = motion.create(Subheading);

const renderLink = (
  link: LinkFieldsFragment | NavbarLinkWithDescriptionFieldsFragment | null,
  index: number,
  showMobileMenu: boolean,
  callback?: () => void
) => {
  switch (link?.__typename) {
    case 'Link': {
      return (
        <Link key={`link2-${index}`} href={getOr(link?.uri, '')} onClick={callback}>
          <MotionSubheading
            whileHover={{ translateX: 5 }}
            small
            classes={clsx('label-lg self-stretch pt-sm !text-md text-white-75', {
              '!text-md-fixed': showMobileMenu,
            })}
          >
            <motion.div layout="position" className="hover:underline">
              {getOr(link.title, '')}
            </motion.div>
          </MotionSubheading>
        </Link>
      );
    }
    case 'NavbarLinkWithDescription': {
      return (
        <div key={`link-${index}`} className="self-stretch">
          <LinkWithDescription data={link} showMobileMenu={showMobileMenu} />
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

const LinkCategory = ({ data, showMobileMenu, idx }: Props) => {
  const setIsFullscreenExhausted = useSetAtom(isFullscreenExhaustedAtom);
  if (!data) {
    return null;
  }

  return (
    <div
      key={`linkCategoryContainer-${idx}`}
      className={`flex flex-1 flex-col flex-wrap content-start items-start gap-lg self-stretch`}
    >
      {data?.childrenCollection?.items?.map((child, index) =>
        renderLink(child, index, showMobileMenu, () => {
          setIsFullscreenExhausted(true);
          document.body.classList.remove('overflow-y-hidden');
        })
      )}
    </div>
  );
};

export default LinkCategory;
